import React, { useEffect, useState, useMemo } from "react";
import { Grid, Container} from "@mui/material";
import Paper from "@mui/material/Paper";
import ChatIcon from "@mui/icons-material/Chat";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Avatar from "../../components/uiElements/avatar/index";
import PersonIcon from "@mui/icons-material/Person";
import Chip from "@mui/material/Chip";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Box, Stack, Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import BallotIcon from "@mui/icons-material/Ballot";
import SunnyCloudIcon from "../../assets/sunny-cloud_icon.svg";
import {
  getActivity,
  getAlerts,
  getClosings,
  getProjectCount,
  resetDashboardData,
} from "../../redux/dashboard/index.js";
import { timesAgo } from "./helpers.js";
import { numberWithCommas } from "../tools/cmas/helper";
import { getMarkets } from "../../redux/agents/addRecruitAgent.js";
import { useNavigate } from "react-router-dom";
import { handleMaximizeTab } from "../../redux/widgets";
import AlertSkelton from "./skeltons/alerts";
import ActivitySkelton from "./skeltons/activitySkelton";
import AgentPoints from "./pointsCard";
import { handleGetEvents } from "../../redux/eventsAndAlerts/events";
import DataNotFound from "../../components/notFound/dataNotFound";
import NoteIcon from "@mui/icons-material/Note";
import ReceiptIcon from "@mui/icons-material/Receipt";
import EventDetail from "../eventsAndAlerts/modals/eventDetail";
import { NumberFormat } from "../../utils/numberFormat";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Popover from '@mui/material/Popover';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/Settings';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import axios from 'axios';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Tooltip from '@mui/material/Tooltip';

function QontoStepIconSkelton(props) {
  const { active, className } = props;
  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      <Skeleton height="33px" width="52px" />{" "}
      <div className="QontoStepIcon-circle" />
    </QontoStepIconRoot>
  );
}

const moment = require("moment-timezone");
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 18,
  alignItems: "center",
  ...(ownerState.active && {
    color: "#784af4",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 12,
  },
  "& .QontoStepIcon-circle": {
    width: 11,
    height: 11,
    marginLeft: "4px",
    borderRadius: "50%",
    color: "#0B0909",
    backgroundColor: "currentColor",
  },
  "& .QontoStepIcon-label": {
    color: "rgba(0, 0, 0, 0.6)",
    fontSize: "15px",
    marginRight: "5px",
  },
}));

function getWeatherEmoji(code) {
  switch (code) {
    case 0: return "☀️"; // Clear sky
    case 1:
    case 2:
    case 3: return "⛅️"; // Partly cloudy
    case 45:
    case 48: return "🌫️"; // Fog
    case 51:
    case 53:
    case 55: return "🌦️"; // Drizzle
    case 61:
    case 63:
    case 65: return "🌧️"; // Rain
    case 71:
    case 73:
    case 75:
    case 77: return "❄️"; // Snow
    case 80:
    case 81:
    case 82: return "🌦️"; // Showers
    case 95:
    case 96:
    case 99: return "⛈️"; // Thunderstorm
    default: return "🌡️"; // Default/unknown
  }
}

function getWeatherDescription(weathercode) {
  const weatherDescriptions = {
    0: 'Clear sky',
    1: 'Mainly clear',
    2: 'Partly cloudy',
    3: 'Overcast',
    45: 'Fog',
    48: 'Depositing rime fog',
    51: 'Light drizzle',
    53: 'Moderate drizzle',
    55: 'Dense drizzle',
    61: 'Slight rain',
    63: 'Moderate rain',
    65: 'Heavy rain',
    71: 'Slight snow',
    73: 'Moderate snow',
    75: 'Heavy snow',
    77: 'Snow grains',
    80: 'Slight rain showers',
    81: 'Moderate rain showers',
    82: 'Violent rain showers',
    85: 'Slight snow showers',
    86: 'Heavy snow showers',
    95: 'Thunderstorm',
    96: 'Thunderstorm with slight hail',
    99: 'Thunderstorm with heavy hail'
  };
  return weatherDescriptions[weathercode] || 'Unknown weather condition';
}

function DashboardStats({ adminAuth }) {
  const [goalModalOpen, setGoalModalOpen] = React.useState(false);
  const [goalValue, setGoalValue] = React.useState(60);
  const [tempGoal, setTempGoal] = React.useState(goalValue);
  const [stats, setStats] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  // Utility to format numbers as $249.9k, $1.15M, etc.
  function formatDollarShort(num) {
    if (num == null || isNaN(num)) return '--';
    if (Math.abs(num) >= 1_000_000) {
      const main = (num / 1_000_000).toFixed(num % 1_000_000 === 0 ? 0 : 2).replace(/\.00$/, '');
      return <>{main}<span style={{ fontSize: '0.5em', verticalAlign: 'bottom', marginLeft: '4px', position: 'relative', top: '-5px', display: 'inline-block' }}>M</span></>;
    }
    if (Math.abs(num) >= 1_000) {
      const main = (num / 1_000).toFixed(num % 1_000 === 0 ? 0 : 1).replace(/\.0$/, '');
      return <>{main}<span style={{ fontSize: '0.5em', verticalAlign: 'bottom', marginLeft: '4px', position: 'relative', top: '-5px', display: 'inline-block' }}>k</span></>;
    }
    return `$${num}`;
  }

  function formatDollarShortPlain(num) {
    if (num == null || isNaN(num)) return '--';
    if (Math.abs(num) >= 1_000_000) {
      return `$${(num / 1_000_000).toFixed(num % 1_000_000 === 0 ? 0 : 2).replace(/\.00$/, '')}M`;
    }
    if (Math.abs(num) >= 1_000) {
      return `$${(num / 1_000).toFixed(num % 1_000 === 0 ? 0 : 1).replace(/\.0$/, '')}k`;
    }
    return `$${num}`;
  }

  React.useEffect(() => {
    const userId = adminAuth?.adminDetail?.id;
    if (!userId) return;
    
    axios.get(`${process.env.REACT_APP_BASE_URL}api/users/stats/${userId}`)
      .then(res => {
        setStats(res.data.data);
        setLoading(false);
      })
      .catch(err => {
        setStats(null);
        setLoading(false);
        console.error(err);
      });

    // Also fetch the user's weekly call goal
    axios.get(`${process.env.REACT_APP_BASE_URL}api/users/${userId}`)
      .then(res => {
        const userData = res.data.data;
        if (userData?.weeklyCallGoal) {
          setGoalValue(userData.weeklyCallGoal);
        }
      })
      .catch(err => {
        console.error('Failed to fetch user data:', err);
      });
  }, [adminAuth?.adminDetail?.id]);

  const handleOpenGoalModal = () => {
    setTempGoal(goalValue);
    setGoalModalOpen(true);
  };
  const handleCloseGoalModal = () => setGoalModalOpen(false);
  const handleSaveGoal = () => {
    const userId = adminAuth?.adminDetail?.id;
    if (!userId) {
      setGoalModalOpen(false);
      return;
    }

    // Update local state immediately for better UX
    setGoalValue(Number(tempGoal));
    setGoalModalOpen(false);

    // Make API call to save the goal
    axios.put(`${process.env.REACT_APP_BASE_URL}api/users/${userId}`, {
      weeklyCallGoal: Number(tempGoal)
    })
    .then(res => {
      console.log('Weekly goal updated successfully:', res.data);
    })
    .catch(err => {
      console.error('Failed to update weekly goal:', err);
      // Revert local state if API call fails
      setGoalValue(60);
      // You could add a toast notification here to inform the user
    });
  };
  return (
    <Grid container spacing={"20px"} sx={{ mb: 1 }}>
      {/* Total Volume YTD */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper
          elevation={2}
          sx={{
            px: 2.5,
            pt: 0.75,
            pb: 0.5,
            borderRadius: "18px",
            background: "rgba(255,255,255,0.95)",
            boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)",
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: 0,
            position: 'relative',
          }}
        >
          <Typography variant="subtitle2" sx={{ color: "#888", mb: 2.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Total Volume YTD
          </Typography>
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Typography variant="h4" sx={{ fontWeight: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {loading ? '--' : (
                (() => {
                  const val = stats?.ytdResult?.currentYTD;
                  if (val == null || isNaN(val)) return '--';
                  let formatted = '';
                  if (Math.abs(val) >= 1_000_000) {
                    const num = (val / 1_000_000).toFixed(val % 1_000_000 === 0 ? 0 : 2).replace(/\.00$/, '');
                    formatted = <>{num}<span style={{ fontSize: '0.5em', verticalAlign: 'bottom', marginLeft: '4px', position: 'relative', top: '-5px', display: 'inline-block' }}>M</span></>;
                  } else if (Math.abs(val) >= 1_000) {
                    const num = (val / 1_000).toFixed(val % 1_000 === 0 ? 0 : 1).replace(/\.0$/, '');
                    formatted = <>{num}<span style={{ fontSize: '0.5em', verticalAlign: 'bottom', marginLeft: '4px', position: 'relative', top: '-5px', display: 'inline-block' }}>k</span></>;
                  } else {
                    formatted = val;
                  }
                  return <><span style={{ fontSize: '0.5em', verticalAlign: 'text-top', fontWeight: 400, marginRight: 2, marginTop: 2, position: 'relative', top: '8px', display: 'inline-block' }}>$</span>{formatted}</>;
                })()
              )}
            </Typography>
            <Typography variant="body2" sx={{ color: "#888", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {loading ? '' : `${stats?.ytdResult?.currentYTDDeals ?? '--'} deals`}
            </Typography>
          </Box>
          <Box sx={{ position: 'absolute', bottom: 16, right: 16 }}>
            {(() => {
              const changeValue = stats?.ytdResult?.volumeChangeFormatted;
              const hasComparison = stats?.ytdResult?.hasComparison;
              const isNull = !hasComparison;
              if (loading || (!changeValue && !isNull)) return null;

              let bgColor, textColor, displayText, tooltipText;
              if (isNull) {
                // Use same coloring as 0% case
                bgColor = "#f5f5f5";
                textColor = "#666";
                displayText = "-";
                tooltipText = "Not enough history to compare to previous year — stay tuned!";
              } else {
                const isPositive = changeValue.includes('+');
                const isNegative = changeValue.includes('-');
                const isZero = changeValue === '0%' || changeValue === '+0%' || changeValue === '-0%';
                if (isZero) {
                  bgColor = "#f5f5f5";
                  textColor = "#666";
                  displayText = "0%";
                } else if (isPositive) {
                  bgColor = "#e6f9e6";
                  textColor = "#228B22";
                  displayText = (
                    <span style={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}>
                      <span style={{ fontSize: '1.1em', marginRight: 4, position: 'relative', top: '-2px' }}>↑</span>
                      <span style={{ fontSize: '1em', fontWeight: 400 }}>{changeValue}</span>
                    </span>
                  );
                } else if (isNegative) {
                  bgColor = "#ffeaea";
                  textColor = "#d32f2f";
                  displayText = (
                    <span style={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}>
                      <span style={{ fontSize: '1.1em', marginRight: 4, position: 'relative', top: '-2px' }}>↓</span>
                      <span style={{ fontSize: '1em', fontWeight: 400 }}>{changeValue}</span>
                    </span>
                  );
                } else {
                  bgColor = "#f5f5f5";
                  textColor = "#666";
                  displayText = changeValue;
                }
                tooltipText = (() => {
                  const rawValue = stats?.ytdResult?.volumeChangeFormatted;
                  const value = rawValue ? rawValue.replace(/^[-+]/, '') : rawValue;
                  const isPositive = rawValue && rawValue.includes('+');
                  const direction = isPositive ? 'increase' : 'decrease';
                  return value ? `${value} ${direction} in sales volume compared to same period last year` : '--';
                })();
              }

              return (
                <Tooltip
                  title={<span style={{ whiteSpace: 'pre-line', fontWeight: 400 }}>{tooltipText}</span>}
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        background: '#23272F',
                        color: '#fff',
                        borderRadius: '16px',
                        fontSize: '14px',
                        padding: '11px 15px',
                        maxWidth: '260px',
                        whiteSpace: 'nowrap',
                        fontWeight: 400,
                        lineHeight: 1.4,
                        boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                      }
                    }
                  }}
                >
                  <Box
                    sx={{
                      px: 1,
                      py: 0.2,
                      bgcolor: bgColor,
                      color: textColor,
                      borderRadius: "8px",
                      fontWeight: 500,
                      fontSize: 13,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                    }}
                  >
                    {displayText}
                  </Box>
                </Tooltip>
              );
            })()}
          </Box>
        </Paper>
      </Grid>
      {/* Active Listings */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper
          elevation={2}
          sx={{
            px: 2.5,
            pt: 0.75,
            pb: 0.5,
            borderRadius: "18px",
            background: "rgba(255,255,255,0.95)",
            boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)",
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: 0,
            position: 'relative',
          }}
        >
          <Typography variant="subtitle2" sx={{ color: "#888", mb: 2.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Total Listings YTD
          </Typography>
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Typography variant="h4" sx={{ fontWeight: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {loading ? '--' : stats?.listingResult?.newListingsYTD?.currentNewListingsYTD ?? '--'}
            </Typography>
            <Typography variant="body2" sx={{ color: "#888", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {loading ? '' : <><span style={{ fontWeight: 500 }}>{formatDollarShortPlain(stats?.listingResult?.newListingsYTD?.newListingYTDVolume)}</span> Volume</>}
            </Typography>
          </Box>
          <Box sx={{ position: 'absolute', bottom: 16, right: 16 }}>
            {(() => {
              const newListingsYTD = stats?.listingResult?.newListingsYTD;
              const previousYearTotal = newListingsYTD?.previousYearTotal;
              const showComparison = newListingsYTD?.showComparison;
              const isNull = !showComparison;
              if (loading || (previousYearTotal == null && !isNull)) return null;

              let bgColor, textColor, displayText, tooltipText;
              if (isNull) {
                // Use same coloring as 0% case
                bgColor = "#f5f5f5";
                textColor = "#666";
                displayText = "-";
                tooltipText = "Not enough history to show previous year data — stay tuned!";
              } else {
                bgColor = '#f5f5f5';
                textColor = '#666';
                displayText = `Last Year: ${previousYearTotal}`;
                tooltipText = `${previousYearTotal} listings earned during the previous calendar year`;
              }

              return (
                <Tooltip
                  title={<span style={{ whiteSpace: 'pre-line', fontWeight: 400 }}>{tooltipText}</span>}
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        background: '#23272F',
                        color: '#fff',
                        borderRadius: '16px',
                        fontSize: '14px',
                        padding: '11px 15px',
                        maxWidth: '260px',
                        whiteSpace: 'pre-line',
                        fontWeight: 400,
                        lineHeight: 1.4,
                        boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                      }
                    }
                  }}
                >
                  <Box
                    sx={{
                      px: 1,
                      py: 0.2,
                      bgcolor: bgColor,
                      color: textColor,
                      borderRadius: "8px",
                      fontWeight: 500,
                      fontSize: 13,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                    }}
                  >
                    {displayText}
                  </Box>
                </Tooltip>
              );
            })()}
          </Box>
        </Paper>
      </Grid>
      {/* Follow-up Tasks */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper
          elevation={2}
          sx={{
            px: 2.5,
            pt: 0.75,
            pb: 0.5,
            borderRadius: "18px",
            background: "rgba(255,255,255,0.95)",
            boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)",
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: 0,
            position: 'relative',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              boxShadow: "0px 15px 60px 0px rgba(0,0,0,0.08)",
              transform: 'translateY(-2px)'
            }
          }}
          onClick={() => window.open('https://method.followupboss.com/2/tasks/overdue', '_blank')}
        >
          <Typography variant="subtitle2" sx={{ color: "#888", mb: 2.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Follow-up Tasks
          </Typography>
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Typography variant="h4" sx={{ fontWeight: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {loading ? '--' : stats?.overdueTasks ?? '--'}
            </Typography>
            <Typography variant="body2" sx={{ color: "#888", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {loading ? '' : `${stats?.overdueTasks === 1 ? 'overdue task' : 'overdue tasks'}`}
            </Typography>
          </Box>
          <Box sx={{ position: 'absolute', bottom: 8, right: 16 }}>
            {loading ? null : (
              stats?.overdueTasks > 0 ? (
                <Tooltip title="Don't get behind! Complete your overdue tasks now to stay on track" placement="top" componentsProps={{ tooltip: { sx: { background: '#23272F', color: '#fff', borderRadius: '16px', fontSize: '14px', padding: '11px 15px', maxWidth: '260px', fontWeight: 400, lineHeight: 1.4, boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', whiteSpace: 'pre-line', wordBreak: 'break-word' } } }}>
                  <ErrorOutlineIcon sx={{ color: '#d32f2f', fontSize: 28 }} />
                </Tooltip>
              ) : (
                <Tooltip title={"All caught up! Great job!"} placement="top" componentsProps={{ tooltip: { sx: { background: '#23272F', color: '#fff', borderRadius: '16px', fontSize: '14px', padding: '11px 15px', maxWidth: '260px', fontWeight: 400, lineHeight: 1.4, boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', whiteSpace: 'pre-line', wordBreak: 'break-word' } } }}>
                  <CheckCircleOutlineIcon sx={{ color: '#66bb6a', fontSize: 28 }} />
                </Tooltip>
              )
            )}
          </Box>
        </Paper>
      </Grid>
      {/* Weekly Calls */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper
          elevation={2}
          sx={{
            px: 2.5,
            pt: 0.75,
            pb: 0.5,
            borderRadius: "18px",
            background: "rgba(255,255,255,0.95)",
            boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)",
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: 0,
            position: 'relative',
          }}
        >
         {/* Settings button in top right */}
         <Box
           sx={{
             position: 'absolute',
             top: 16,
             right: 16,
             zIndex: 2,
             background: '#ededed',
             borderRadius: '6px',
             p: 0,
             display: 'flex',
             alignItems: 'center',
             justifyContent: 'center',
           }}
         >
           <IconButton
             size="small"
             onClick={handleOpenGoalModal}
             aria-label="Adjust Weekly Goal"
             sx={{
               background: 'transparent',
               boxShadow: 'none',
               '&:hover': { background: 'transparent' }
             }}
           >
             <SettingsIcon fontSize="small" sx={{ color: '#888' }} />
           </IconButton>
         </Box>
          <Typography variant="subtitle2" sx={{ color: "#888", mb: 2.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Weekly Calls
          </Typography>
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Typography variant="h4" sx={{ fontWeight: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {loading ? '--' : stats?.callResult?.currentWeekCalls ?? '--'}
            </Typography>
           <Typography variant="body2" sx={{ color: "#888", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
             / {goalValue} goal
           </Typography>
          </Box>
          <Box sx={{ position: 'absolute', bottom: 16, right: 16 }}>
            {(() => {
              const current = stats?.callResult?.currentWeekCalls;
              const goal = goalValue;
              if (loading || current == null || goal == null || isNaN(current) || isNaN(goal) || goal === 0) return null;

              const percent = Math.round((current / goal) * 100);
              let bgColor, textColor, tooltipText;
              if (percent <= 25) {
                bgColor = "#f5f5f5";
                textColor = "#666";
                tooltipText = "Rome wasn't built in a day - you've got this!";
              } else if (percent > 25 && percent <= 50) {
                bgColor = "#fff3e0";
                textColor = "#ff9800";
                tooltipText = "You're on the right track - stay consistent!";
              } else if (percent > 50 && percent < 90) {
                bgColor = "#e3f2fd";
                textColor = "#1976d2";
                tooltipText = "Excellent progress - push through to 100%!";
              } else if (percent >= 90 && percent < 100) {
                bgColor = "#e6f9e6";
                textColor = "#228B22";
                tooltipText = "Almost to the finish line! Don't quit now!";
              } else if (percent >= 100) {
                bgColor = "#e6f9e6";
                textColor = "#228B22";
                tooltipText = "Goal achieved! You're a calling machine!";
              }

              return (
                <Tooltip
                  title={<span style={{ whiteSpace: 'pre-line', fontWeight: 400 }}>{tooltipText}</span>}
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        background: '#23272F',
                        color: '#fff',
                        borderRadius: '16px',
                        fontSize: '14px',
                        padding: '11px 15px',
                        maxWidth: '260px',
                        whiteSpace: 'nowrap',
                        fontWeight: 400,
                        lineHeight: 1.4,
                        boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                      }
                    }
                  }}
                >
                  <Box
                    sx={{
                      px: 1,
                      py: 0.2,
                      bgcolor: bgColor,
                      color: textColor,
                      borderRadius: "8px",
                      fontWeight: 500,
                      fontSize: 13,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                    }}
                  >
                    {`${percent}%`}
                  </Box>
                </Tooltip>
              );
            })()}
          </Box>
         {/* Modal for adjusting weekly goal */}
         <Dialog
           open={goalModalOpen}
           onClose={handleCloseGoalModal}
           maxWidth="xs"
           fullWidth
           PaperProps={{
             sx: {
               borderRadius: 3,
               boxShadow: 8,
               p: 0,
               background: '#fff',
             }
           }}
           BackdropProps={{ sx: { background: 'rgba(210, 214, 221, 0.85)' } }}
         >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#f5f5f5', borderTopLeftRadius: 10, borderTopRightRadius: 10, p: 1.2, pb: 1 }}>
              <Typography sx={{ fontWeight: 500, fontSize: 16, color: '#222', pl: 1 }}>
                Adjust Weekly Goal
              </Typography>
              <IconButton onClick={handleCloseGoalModal} sx={{ color: '#888', p: 0.5 }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <DialogContent sx={{ textAlign: 'left', pt: 2, pb: 2, background: '#fff' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Weekly Goal Amount"
                  type="number"
                  fullWidth
                  value={tempGoal}
                  onChange={e => setTempGoal(e.target.value)}
                  inputProps={{ min: 1, style: { fontSize: 16, textAlign: 'left', fontWeight: 500 } }}
                  sx={{ maxWidth: 220, mb: 1, '& .MuiInputBase-root': { height: 42 }, '& .MuiInputBase-input': { py: 0.8 } }}
                />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', ml: 1, gap: 0.5, flex: 1 }}>
                  <Button
                    onClick={handleCloseGoalModal}
                    variant="outlined"
                    sx={{
                      fontSize: 14,
                      px: 1.5,
                      py: 0.7,
                      borderRadius: 2,
                      borderColor: '#bbb',
                      color: '#222',
                      background: '#fff',
                      fontWeight: 500,
                      mr: 0.5,
                      boxShadow: 'none',
                      minWidth: 0,
                      '&:hover': { background: '#f5f5f5', borderColor: '#888' }
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSaveGoal}
                    variant="contained"
                    sx={{
                      fontSize: 14,
                      px: 1.5,
                      py: 0.7,
                      borderRadius: 2,
                      background: '#111',
                      color: '#fff',
                      fontWeight: 500,
                      boxShadow: 'none',
                      minWidth: 0,
                      '&:hover': { background: '#222' }
                    }}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            </DialogContent>
         </Dialog>
        </Paper>
      </Grid>
    </Grid>
  );
}

function MainDashBoard(props) {
  const { classes } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const [eventData, setEventData] = useState({});
  const [openEventDetail, setOpenEventDetail] = useState(false);
  const adminAuth = useSelector((state) => state.adminAuth);
  const eventList = useSelector((item) => item.eventAlerts.events.eventList);
  const {
    closings,
    closingsLoading,
    activities,
    activityLoading,
    alertsLoading,
    alerts: { count, rows },
    projectCount,
  } = useSelector((state) => state.dashboard);
  const [weather, setWeather] = useState(null);
  const [weatherLoading, setWeatherLoading] = useState(true);
  const [location, setLocation] = useState("Your Location");
  const [showAllActivities, setShowAllActivities] = useState(false);
  const [showAllClosings, setShowAllClosings] = useState(false);
  const pointsData = useSelector(state => state.agentRoster.points.pointsData);
  const [activityAnchorEl, setActivityAnchorEl] = useState(null);
  const [openActivityId, setOpenActivityId] = useState(null);

  // Fun greetings array
  const greetings = [
    "Hey",
    "Hello",
    "Hi there",
    "Howdy",
    "Greetings",
    "What's up",
    "Ahoy",
    "Heya",
    "Salutations",
    "Bonjour",
    "Look who it is",
    "Happy to see you"
  ];
  // Pick a random greeting only on mount
  const randomGreeting = useMemo(
    () => greetings[Math.floor(Math.random() * greetings.length)],
    []
  );

  useEffect(() => {
    setTimeout(() => {
      dispatch(getProjectCount());
      dispatch(getActivity());
      dispatch(getAlerts(offset));
      dispatch(getClosings({ id: adminAuth?.adminDetail?.id }));
      dispatch(getMarkets());
    }, 2000);

    return () => {
      dispatch(resetDashboardData);
    };
  }, [adminAuth.isAuthenticated === true]);

  function fetchCityState(lat, lon) {
    fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`)
      .then(res => res.json())
      .then(data => {
        const city = data.address.city || data.address.town || data.address.village || data.address.hamlet || "";
        const stateShort = data.address.state_code || "";
        const stateFull = data.address.state || "";
        let stateDisplay = stateShort || stateFull;
        setLocation(`${city}${city && stateDisplay ? ', ' : ''}${stateDisplay}`);
      })
      .catch(() => setLocation("Your Location"));
  }

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          fetchCityState(latitude, longitude);
          const apiBase = process.env.REACT_APP_BASE_URL || 'http://localhost:3000';
          fetch(`${apiBase}api/weather/current?latitude=${latitude}&longitude=${longitude}`)
            .then(res => res.json())
            .then(data => {
              console.log('Weather API response:', data);
              setWeather(data?.data);
              setWeatherLoading(false);
            })
            .catch((err) => {
              console.log('Weather fetch error:', err);
              setWeatherLoading(false);
            });
        },
        (error) => {
          setLocation("Weather data unavailable");
          setWeather(null);
          setWeatherLoading(false);
        }
      );
    } else {
      setWeatherLoading(false);
    }
  }, []);

  const handleMaximize = (data) => {
    dispatch(handleMaximizeTab(data));
  };

  useEffect(() => {
    dispatch(
      handleGetEvents({
        pageNumber: 1,
        pageSize: 4,
        view_past_events: false,
        search: "",
        path: "user-events",
      })
    );
  }, []);

  function QontoStepIcon(props) {
    const { active, className, icon } = props;
    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        <div className="QontoStepIcon-label">
          {moment(eventList?.data?.data[icon - 1].event_date)
            .tz("America/New_York")
            .format("MMM DD")}{" "}
        </div>{" "}
        <div className="QontoStepIcon-circle" />
      </QontoStepIconRoot>
    );
  }

  const getCurrentGreeting = () => {
    let myDate = new Date();
    let hrs = myDate.getHours();
    let greet;
    if (hrs < 12) greet = "Good Morning";
    else if (hrs >= 12 && hrs <= 17) greet = "Good Afternoon";
    else if (hrs >= 17 && hrs <= 24) greet = "Good Evening";
    return greet;
  };

  useEffect(() => {
    const main = document.getElementById("main-section");
    if (main) {
      main.style.paddingBottom = "0";
      main.style.background = "transparent";
    }
  }, []);

  const handleActivityClick = (activityId, event) => {
    setActivityAnchorEl(event.currentTarget);
    setOpenActivityId(activityId);
  };
  const handleActivityClose = () => {
    setActivityAnchorEl(null);
    setOpenActivityId(null);
  };

  return (
    <div
      className="dashboard-gradient-bg"
      style={{
        minHeight: "100vh",
        height: "100%",
        background: "#f8f8f8",
        overflowX: "hidden",
        boxSizing: "border-box",
        paddingBottom: '48px'
      }}
    >
      <Container maxWidth="xl" style={{ background: "transparent" }}>
        <div className={classes.mainDashboardPage}>
          {/* Greeting, Date, Weather Section - Figma style, separated */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '32px',
            position: 'relative'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Avatar
                src={adminAuth?.adminDetail?.profile_img || ""}
                alt={adminAuth?.adminDetail?.full_name}
                sx={{ width: 59, height: 59, marginRight: 2 }}
              >
                {adminAuth?.adminDetail?.first_name && adminAuth?.adminDetail?.last_name
                  ? `${adminAuth.adminDetail.first_name[0]}${adminAuth.adminDetail.last_name[0]}`
                  : adminAuth?.adminDetail?.full_name?.[0]}
              </Avatar>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', mt: 0.5 }}>
                <Typography variant="h4" sx={{ fontWeight: 400, fontSize: 21, lineHeight: 1.1, mb: '4px' }}>
                  {randomGreeting}, {adminAuth?.adminDetail?.first_name}!
                  <span role="img" aria-label="wave"> 👋</span>
                </Typography>
                <Typography variant="subtitle1" sx={{ color: '#888', fontSize: 14.75, fontWeight: 400 }}>
                  {`It's ${moment().format('dddd, MMMM Do, YYYY')}`}
                </Typography>
              </Box>
            </Box>
            {(!weather || weather.weathercode === undefined || weather.weathercode === null) ? (
              <Tooltip 
                title="Please enable location services to view weather data." 
                placement="top"
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '14px',
                      padding: '8px 12px',
                      maxWidth: 'none',
                      whiteSpace: 'nowrap',
                      background: 'linear-gradient(to right, rgba(100, 100, 100, 0.05), rgba(50, 50, 50, 0.1))',
                      backdropFilter: 'blur(8px)',
                      WebkitBackdropFilter: 'blur(8px)',
                      color: '#666'
                    }
                  }
                }}
              >
                <Paper
                  elevation={2}
                  sx={{
                    background: "transparent",
                    border: "2px solid #e0e0e0",
                    boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)",
                    borderRadius: "18px",
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 20px',
                    minWidth: '240px',
                    maxWidth: '340px',
                    minHeight: '70px',
                    marginRight: 0,
                    marginLeft: 'auto',
                    gap: 2
                  }}
                >
                  <Box sx={{ textAlign: 'left', flex: 1 }}>
                    <Typography variant="body2" sx={{ color: '#888', fontWeight: 400, fontSize: 15, lineHeight: 1.1 }}>
                      Weather<br/>Unavailable
                    </Typography>
                  </Box>
                  <span style={{ fontSize: '2.5rem' }}>{getWeatherEmoji()}</span>
                </Paper>
              </Tooltip>
            ) : (
              <Paper
                elevation={2}
                sx={{
                  background: "transparent",
                  border: "2px solid #e0e0e0",
                  boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)",
                  borderRadius: "18px",
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 20px',
                  minWidth: '240px',
                  maxWidth: '340px',
                  minHeight: '70px',
                  marginRight: 0,
                  marginLeft: 'auto',
                  gap: 2
                }}
              >
                <Box sx={{ textAlign: 'left', flex: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: 14 }}>
                    {weather.description}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: 13, color: '#222' }}>
                    H: {weather?.high !== undefined ? Math.round(weather.high) + '°' : ''} &nbsp; L: {weather?.low !== undefined ? Math.round(weather.low) + '°' : ''}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: 13, color: '#222' }}>
                    {location}
                  </Typography>
                </Box>
                <span style={{ fontSize: '2.5rem' }}>{getWeatherEmoji(weather.weathercode)}</span>
              </Paper>
            )}
          </Box>
          <DashboardStats adminAuth={adminAuth} />
          <Grid container spacing={"20px"} sx={{ mb: 0, mt: -1, pt: 0 }}>
            <Grid item xs={12} md={6}>
              <Paper
                elevation={2}
                className={classes.boxArea}
                sx={{ minHeight: 315, background: "rgba(255,255,255,0.8)", boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)", border: "none", borderRadius: "18px", marginTop: 0, mt: 0, pt: 0 }}
              >
                <Box sx={{ padding: '24px 24px 0 24px' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: '2px', mt: 0.5 }}>
                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <PersonIcon sx={{ color: '#fff', fontSize: 22 }} />
                    </Box>
                    <Box>
                      <Typography variant="h5" sx={{ fontWeight: 500, fontSize: 18, color: '#111', lineHeight: 1, mb: 0.875 }}>Lead Activity</Typography>
                      <Typography variant="subtitle1" sx={{ color: '#888', fontSize: 15, fontWeight: 400, lineHeight: 1, mt: 0 }}>{'Recent property views, saves, and more'}</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ px: 2, pb: 2, mt: 3, pt: 0 }}>
                  {activityLoading && <ActivitySkelton count={5} />}
                  {!activityLoading && activities?.length === 0 && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '140px', mt: 6 }}>
                      <Typography sx={{ fontSize: 40, mb: 1 }}>🔍</Typography>
                      <Typography sx={{ color: '#BDBDBD', fontSize: 16, fontWeight: 500, textAlign: 'center' }}>
                        No recent activity... yet!<br />Time to make some moves!
                      </Typography>
                    </Box>
                  )}
                  {!activityLoading && (showAllActivities ? activities : activities?.slice(0, 5))?.map((lead, idx) => {
                    const mainEvent = lead.mainEvent;
                    const allEvents = lead.allEventsForDay || [];
                    const moreCount = allEvents.length - 1;
                    return (
                      <Box key={mainEvent.id || idx} sx={{ display: 'flex', alignItems: 'center', background: '#fff', borderRadius: '18px', boxShadow: '0 4px 16px 0 rgba(0,0,0,0.08)', p: 1.25, pl: 1.75, pr: 2.5, mb: 1.25, minHeight: 58, maxWidth: '100%', overflow: 'hidden', py: 1.34 }}>
                        {/* Avatar */}
                        {(() => {
                          let avatarUrl;
                          if (mainEvent.person?.picture && mainEvent.person?.picture !== "null") {
                            try {
                              const picObj = typeof mainEvent.person.picture === "string"
                                ? JSON.parse(mainEvent.person.picture)
                                : mainEvent.person.picture;
                              avatarUrl = picObj?.small || undefined;
                            } catch {
                              avatarUrl = mainEvent.person.picture;
                            }
                          } else {
                            avatarUrl = undefined;
                          }
                          return (
                      <Avatar
                              src={avatarUrl}
                              sx={{ width: 36, height: 36, fontWeight: 500, fontSize: 15, bgcolor: mainEvent?.color || '#e0e0e0', mr: 2.25 }}
                        variant="circular"
                      >
                              {!avatarUrl && (mainEvent.person?.firstName
                                ? `${mainEvent.person?.firstName[0]}${mainEvent.person?.lastName?.[0] || ''}`
                                : <PersonIcon />)}
                      </Avatar>
                          );
                        })()}
                        {/* Name and property info */}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontWeight: 500, fontSize: 14, color: '#222', lineHeight: 1, mb: 0.25, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%', position: 'relative', top: '1px' }}>
                            {mainEvent.person?.firstName || ''} {mainEvent.person?.lastName || ''}
                          </Typography>
                        <Typography
                          sx={{
                            fontSize: 14,
                            color: '#666',
                            mt: 0.5,
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: 0,
                            maxWidth: '100%',
                            whiteSpace: 'nowrap',
                              position: 'relative',
                              top: '1px',
                          }}
                        >
                          <Box component="span" sx={{ flexShrink: 0, mr: 0.5 }}>
                              {mainEvent.type ? `${mainEvent.type}:` : ''}
                          </Box>
                          <Box
                            sx={{
                                color: '#64b5f6', 
                              fontWeight: 500,
                              fontSize: 14,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              minWidth: 0,
                              flex: 1,
                              display: 'block',
                                maxWidth: '100%',
                                cursor: moreCount > 0 ? 'pointer' : (mainEvent.property?.url ? 'pointer' : 'default'),
                                textDecoration: 'none',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                            }}
                              onClick={moreCount > 0 ? (e) => handleActivityClick(idx, e) : undefined}
                              component={moreCount === 0 && mainEvent.property?.url ? 'a' : 'span'}
                              href={moreCount === 0 && mainEvent.property?.url ? mainEvent.property.url : undefined}
                              target={moreCount === 0 && mainEvent.property?.url ? '_blank' : undefined}
                              rel={moreCount === 0 && mainEvent.property?.url ? 'noopener noreferrer' : undefined}
                          >
                              {mainEvent.property?.street || ''}
                              {moreCount > 0 && ` + ${moreCount} More`}
                          </Box>
                        </Typography>
                      </Box>
                        {/* Time and icon */}
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Typography sx={{ color: '#BDBDBD', fontSize: 14, fontWeight: 500, textAlign: 'right', mr: 1.25 }}>
                            <Tooltip title={mainEvent.occured ? moment(mainEvent.occured).format('MMMM D, YYYY h:mm A') : ''} arrow placement="top">
                            <span style={{ display: 'inline-block' }}>
                                {mainEvent.occured ? timesAgo(mainEvent.occured) : ''}
                            </span>
                          </Tooltip>
                        </Typography>
                      </Box>
                        {mainEvent.type === 'Saved Property' ? (
                        <Box sx={{ color: '#E5738A', fontSize: 21, ml: 1, display: 'flex', alignItems: 'center' }}>
                          <FavoriteRoundedIcon sx={{ fontSize: 21 }} />
                        </Box>
                      ) : (
                        <Box sx={{ color: '#5A90E6', fontSize: 21, ml: 1, display: 'flex', alignItems: 'center' }}>
                          <VisibilityIcon sx={{ fontSize: 21 }} />
                        </Box>
                      )}
                        {/* +X More Popover */}
                        <Popover
                          open={openActivityId === idx}
                          anchorEl={activityAnchorEl}
                          onClose={() => setOpenActivityId(null)}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                          PaperProps={{ sx: { borderRadius: 2, minWidth: 420, maxWidth: 540, px: 2, pt: 1.75, pb: 0.75 } }}
                        >
                          {allEvents.map((event, i) => (
                            <Box key={event.id || i} sx={{ mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 220 }}>
                              <Typography 
                                sx={{ 
                                  fontWeight: 500, 
                                  fontSize: 14, 
                                  color: '#64b5f6', 
                                  textDecoration: 'none', 
                                  cursor: event.property?.url ? 'pointer' : 'default', 
                                  overflow: 'hidden', 
                                  textOverflow: 'ellipsis', 
                                  whiteSpace: 'nowrap', 
                                  maxWidth: 320, 
                                  '&:hover': { 
                                    textDecoration: 'underline', 
                                    color: '#64b5f6' 
                                  } 
                                }}
                                component={event.property?.url ? 'a' : 'span'}
                                href={event.property?.url || undefined}
                                target={event.property?.url ? '_blank' : undefined}
                                rel={event.property?.url ? 'noopener noreferrer' : undefined}
                              >
                                {event.property?.street || ''}
                              </Typography>
                              <Typography sx={{ fontSize: 13, color: '#888', ml: 2, flexShrink: 0 }}>
                                {event.occured ? moment(event.occured).format('D MMM YYYY h:mm A') : ''}
                              </Typography>
                    </Box>
                  ))}
                        </Popover>
                      </Box>
                    );
                  })}
                  {!activityLoading && activities?.length > 5 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                      <Button
                        variant="text"
                        onClick={() => setShowAllActivities((prev) => !prev)}
                        sx={{
                          background: '#F7F7F7',
                          borderRadius: '24px',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#888',
                          px: 5,
                          py: 0.6,
                          minHeight: '22px',
                          width: '100%',
                          maxWidth: '100%',
                          boxShadow: 'none',
                          textTransform: 'none',
                          '&:hover': { background: '#ececec' }
                        }}
                      >
                        {showAllActivities ? 'Show Less' : 'View More'}
                        {showAllActivities ? (
                          <ExpandLessIcon sx={{ fontSize: 18, ml: 1 }} />
                        ) : (
                          <ExpandMoreIcon sx={{ fontSize: 18, ml: 1 }} />
                        )}
                      </Button>
                    </Box>
                  )}
                </Box>
              </Paper>

              <Paper
                elevation={2}
                className={classes.boxArea}
                sx={{ minHeight: 315, background: "rgba(255,255,255,0.8)", boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)", border: "none", borderRadius: "18px", marginTop: "20px" }}
              >
                <Box sx={{ padding: '24px 24px 0 24px', pb: 0.1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: '2px', mt: 0.5 }}>
                    <Box sx={{ width: 40, height: 40, borderRadius: '50%', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <WorkOutlineIcon sx={{ color: '#fff', fontSize: 22 }} />
                    </Box>
                    <Box>
                      <Typography variant="h5" sx={{ fontWeight: 500, fontSize: 18, color: '#111', lineHeight: 1, mb: 0.875 }}>Recent Closings</Typography>
                      <Typography variant="subtitle1" sx={{ color: '#888', fontSize: 15, fontWeight: 400, lineHeight: 1, mt: 0 }}>Track your transactions and commission details</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ px: 1, pb: 2, pt: 1.25, mt: 1.4, overflowX: 'auto', height: 'auto', minHeight: 'unset' }}>
                  {closingsLoading && <ActivitySkelton hideAvatar count={5} />}
                  {!closingsLoading && closings?.length === 0 && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '140px', mt: 2 }}>
                      <Typography sx={{ fontSize: 40, mb: 1 }}>💼</Typography>
                      <Typography sx={{ color: '#BDBDBD', fontSize: 16, fontWeight: 500, textAlign: 'center' }}>
                        No closings yet—<br />your next win is just around the corner!
                      </Typography>
                    </Box>
                  )}
                  {!closingsLoading && (showAllClosings ? closings : closings?.slice(0, 5))?.map((item, idx) => (
                    <Box key={idx} sx={{ display: 'flex', alignItems: 'center', background: '#fff', borderRadius: '18px', boxShadow: '0 4px 16px 0 rgba(0,0,0,0.08)', p: 0.9, pl: 2.1, pr: 2.5, mb: 1.25, minHeight: 40, maxWidth: '100%', overflow: 'hidden', mx: 1.5 }}>
                      <Box sx={{ flex: 1.6, minWidth: 0, mr: 0 }}>
                        <Box>
                        <Typography
                          sx={{
                              fontWeight: 500,
                            fontSize: 14,
                            color: '#222',
                            lineHeight: 1.1,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                              display: 'inline-flex',
                              alignItems: 'center',
                              position: 'relative',
                              top: '-1px',
                          }}
                        >
                            {item.transaction_contract?.street}
                        </Typography>
                          <Typography
                          sx={{
                              fontSize: 14,
                              color: '#444',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              position: 'relative',
                              top: '-1px',
                            }}
                          >
                            {[item.transaction_contract?.city, item.transaction_contract?.state, item.transaction_contract?.zipcode].filter(Boolean).join(', ').replace(/, (?=\d{5}$)/, ' ')}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ flex: 0.7, minWidth: 0, textAlign: 'left' }}>
                        <Typography sx={{ fontWeight: 550, fontSize: 13, color: '#222', mb: 0.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 80 }}>Closed On</Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: 14, color: '#666' }}>{item.closing_date ? moment(item.closing_date).format('M/D/YY') : (item.createdAt ? moment(item.createdAt).format('M/D/YY') : '')}</Typography>
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                        <Typography sx={{ fontWeight: 550, fontSize: 13, color: '#222', mb: 0.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>Commission Amt</Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: 14, color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>{item.amount ? `$${numberWithCommas(item.amount)}` : ''}</Typography>
                      </Box>
                      <Box sx={{ flex: 0, minWidth: 70, ml: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Box
                          sx={{
                            background: item.status === 'Paid' ? '#E6F9E6' : '#E5E5E5',
                            color: item.status === 'Paid' ? '#228B22' : '#111',
                            borderRadius: '8px',
                            px: 1.25,
                            py: 0.5,
                            fontWeight: 500,
                            fontSize: 13,
                            minWidth: 'unset',
                            textAlign: 'center',
                            display: 'inline-block',
                          }}
                        >
                          {item.status === 'Processed' ? 'Processing' : item.status}
                        </Box>
                      </Box>
                    </Box>
                  ))}
                  {!closingsLoading && closings?.length > 5 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                      <Button
                        variant="text"
                        onClick={() => setShowAllClosings((prev) => !prev)}
                        sx={{
                          background: '#F7F7F7',
                          borderRadius: '24px',
                          fontWeight: 500,
                          fontSize: 14,
                          color: '#888',
                          px: 5,
                          py: 0.6,
                          minHeight: '22px',
                          width: '100%',
                          mx: 1.5,
                          boxShadow: 'none',
                          textTransform: 'none',
                          '&:hover': { background: '#ececec' }
                        }}
                      >
                        {showAllClosings ? 'Show Less' : 'View More'}
                        {showAllClosings ? (
                          <ExpandLessIcon sx={{ fontSize: 18, ml: 1 }} />
                        ) : (
                          <ExpandMoreIcon sx={{ fontSize: 18, ml: 1 }} />
                        )}
                      </Button>
                    </Box>
                  )}
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box>
                <AgentPoints adminDetail={adminAuth?.adminDetail} {...props} />
              </Box>

              <Paper
                elevation={2}
                className={classes.boxArea}
                sx={{ minHeight: 315, background: "rgba(255,255,255,0.8)", boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)", border: "none", borderRadius: "18px", marginTop: "20px" }}
              >
                <Box sx={{ padding: '24px 24px 0 24px' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5, mt: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Box sx={{ width: 40, height: 40, borderRadius: '50%', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CalendarTodayIcon sx={{ color: '#fff', fontSize: 22 }} />
                      </Box>
                      <Box>
                        <Typography variant="h5" sx={{ fontWeight: 500, fontSize: 18, color: '#111', lineHeight: 1, mb: 0.875 }}>
                          Upcoming Events & Training
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: '#888', fontSize: 15, fontWeight: 400, lineHeight: 1, mt: 0 }}>
                          Workshops, classes, and company events
                        </Typography>
                      </Box>
                    </Box>
                    {eventList.data?.data?.length > 4 ? (
                      <Button
                        onClick={() =>
                          navigate(`/events_and_alerts/events`, {
                            state: { dashboardView: true },
                          })
                        }
                        sx={{
                          border: "1px solid rgba(33, 33, 33, 0.4)",
                          height: "32px",
                          mr: "20px",
                          mt: "-12px",
                          whiteSpace: "nowrap",
                        }}
                        variant="outlined"
                        color="inherit"
                        size="small"
                      >
                        View All
                      </Button>
                    ) : null}
                  </Box>
                </Box>

                <Box
                  className={classes.boxDashboard}
                  sx={{ minHeight: "239px !important", pt: 0, pb: 0 }}
                >
                  <Stepper
                    activeStep={3}
                    orientation="vertical"
                    connector={<QontoConnector />}
                  >
                    {eventList.isLoading ? (
                      <Paper elevation={2} className={classes.boxArea}>
                        <h2 className={classes.boxDashboardTitle}>
                          <Skeleton
                            variant="rectangular"
                            height="30px"
                            width="50%"
                          />
                        </h2>
                        <Box className={classes.boxDashboard}>
                          <Stepper
                            activeStep={3}
                            orientation="vertical"
                            connector={<QontoConnector />}
                          >
                            {Array.from(Array(4).keys()).map((step, index) => (
                              <Step expanded key={step.label}>
                                <StepLabel
                                  StepIconComponent={QontoStepIconSkelton}
                                >
                                  <Skeleton height="25px" width="210px" />
                                </StepLabel>
                                <StepContent
                                  TransitionProps={{ unmountOnExit: false }}
                                >
                                  <Typography>
                                    <Skeleton height="25px" width="110px" />
                                  </Typography>
                                </StepContent>
                              </Step>
                            ))}
                          </Stepper>
                        </Box>
                      </Paper>
                    ) : (
                      ""
                    )}
                    {eventList.data?.data?.length && !eventList.isLoading
                      ? eventList.data?.data?.slice(0, 4)?.map((item, index) => (
                          <Step
                            expanded
                            key={item.id}
                            onClick={() => {
                              setEventData(item);
                              setOpenEventDetail(true);
                            }}
                            sx={{ cursor: "pointer" }}
                          >
                            <StepLabel StepIconComponent={QontoStepIcon}>{`${
                              item.title
                            }:  ${moment(item.start_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )} at ${
                              item.location_title || item.location
                            }`}</StepLabel>
                            <StepContent
                              TransitionProps={{ unmountOnExit: false }}
                            >
                              <Typography
                                className={classes.eventStepperDescription}
                              >
                                {" "}
                                {item.body}
                              </Typography>
                            </StepContent>
                          </Step>
                        ))
                      : ""}
                    {!eventList.isLoading && !eventList.data?.data?.length ? (
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '195px', height: '195px', pt: 0.5, pb: 0.5 }}>
                        <Typography sx={{ fontSize: 40, mb: 1 }}>🔮</Typography>
                        <Typography 
                          sx={{ 
                            color: '#BDBDBD', fontSize: 16, fontWeight: 500, textAlign: 'center',
                            '& a': {
                              color: '#64b5f6',
                              textDecoration: 'none',
                              fontWeight: 500,
                              transition: 'text-decoration 0.2s',
                            },
                            '& a:hover': {
                              textDecoration: 'underline',
                              color: '#64b5f6',
                            }
                          }}
                        >
                          This section is coming soon!<br />In the meantime, check your <a href="https://calendar.google.com/" target="_blank" rel="noopener noreferrer">Google Calendar</a> for all the magic.
                        </Typography>
                      </Box>
                    ) : null}
                  </Stepper>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </Container>
      <EventDetail
        open={openEventDetail}
        setOpen={setOpenEventDetail}
        eventData={eventData}
      />
    </div>
  );
}
export default withStyles(styleSheet, { name: "MainDashBoardStyle" })(
  MainDashBoard
);
